'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _SVGContainer = require('../SVGContainer');

var _SVGContainer2 = _interopRequireDefault(_SVGContainer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TagIcon = function TagIcon(props) {
  return _react2.default.createElement(
    _SVGContainer2.default,
    props,
    _react2.default.createElement('path', { d: 'M4.008 12.993c0 .132.053.26.147.352L18.66 27.853c.094.093.222.146.353.146.133 0 .26-.055.354-.147l8.486-8.485c.094-.094.147-.22.147-.354 0-.133-.053-.26-.146-.353L13.346 4.154c-.094-.094-.22-.146-.354-.146L4.5 4c-.133 0-.26.053-.354.146C4.052 4.24 4 4.368 4 4.5l.008 8.493zM12 9.5c0 1.378-1.122 2.5-2.5 2.5C8.12 12 7 10.878 7 9.5 7 8.12 8.12 7 9.5 7 10.878 7 12 8.12 12 9.5z' })
  );
};

TagIcon.propTypes = {
  size: _react.PropTypes.oneOf(['small', 'medium', 'large'])
};

exports.default = TagIcon;